<template>
  <!--
    SaleTechnicalDrawingPrint
    -------------------------------------------------------------------------
    Casca fina da impressão do desenho técnico: uma <TechnicalSheet> (prancha
    profissional com moldura, escala, legenda e carimbo) por produto com
    ficha técnica.

    É renderizada oculta; SaleView copia o innerHTML de
    #print-technical-drawing para a janela de impressão e injeta
    STD_CANVAS_CSS + SHEET_PRINT_CSS (fonte única em
    engine/print/stdCanvasStyles.js).
  -->
  <div v-show="false" id="print-technical-drawing">
    <TechnicalSheet
      v-for="(product, pi) in printableProducts"
      :key="`tech-sheet-${pi}`"
      :product="product"
      :sale="sale"
      :tenant="tenant"
      :sheet-number="pi + 1"
      :total-sheets="printableProducts.length"
    />
    <div v-if="!printableProducts.length" style="padding: 20px; text-align: center; color: #555;">
      Nenhuma peça com ficha técnica para imprimir.
    </div>
  </div>
</template>

<script>
import TechnicalSheet from "@/components/stone-technical-drawing/TechnicalSheet.vue";

export default {
  name: "SaleTechnicalDrawingPrint",
  components: { TechnicalSheet },
  props: {
    lastSell: { type: Object, required: true },
    getLoggedUser: { type: Object, default: () => ({}) }
  },
  computed: {
    sale() {
      return this.lastSell || {};
    },
    tenant() {
      const t = this.getLoggedUser && this.getLoggedUser.tenant;
      return (t && t[0]) || {};
    },
    printableProducts() {
      const produtos = (this.sale.compra && this.sale.compra.produtos) || [];
      return produtos.filter(
        p => Array.isArray(p.ficha_tecnica) && p.ficha_tecnica.length
      );
    }
  }
};
</script>
